export default "__VITE_ASSET__I$MbkCfX__"